/* eslint-disable react/react-in-jsx-scope */
import { Tooltip } from "antd";
import classNames from "classnames";
import { CommonService } from "@Services/common-service";
import { Close } from "@carbon/icons-react";
import "./Tag.scss";
import { TAG_STATUS } from "@Configs/enum";

export interface TagProps {
  /**Used to change style Component */
  className?: string;
  /**Value of Tag*/
  value?: string;
  /**Set background color Tag */
  backgroundColor?: string;
  /**Set color Tag */
  color?: string;
  /**Max length of display value */
  countCharacters?: number;
  /** Provide a custom action (onClick) to the component */
  action?: () => void;
  /**Option change size of component */
  size?: "sm" | "md";
  /**Status of the Tag. */
  status?: TAG_STATUS;

  isShowBorder?: boolean;

  isShowDot?: boolean;

  colorDot?: string;

  colorBorder?: string;
}

function Tag(props: TagProps) {
  const {
    className,
    color,
    value,
    backgroundColor,
    countCharacters,
    action,
    size = "md",
    status = TAG_STATUS.DEFAULT,
    isShowBorder = false,
    isShowDot = true,
    colorDot,
    colorBorder,
  } = props;

  const getBackgroundColor = () => {
    switch (status) {
      case TAG_STATUS.SUCCESS:
        return "var(--palette-base-green-1)";
      case TAG_STATUS.ERROR:
        return "var(--palette-base-red-1)";
      case TAG_STATUS.INFO:
        return "var(--palette-base-blue-1)";
      case TAG_STATUS.IN_PROGRESS:
        return "var(--palette-base-orange-1)";
      case TAG_STATUS.CLOSE:
        return "var(--palette-base-verified-lighter)";
      case TAG_STATUS.DEFAULT:
      default:
        return "var(--palette-base-neutral-3)";
    }
  };

  const getColorText = () => {
    switch (status) {
      case TAG_STATUS.SUCCESS:
        return "var(--palette-base-green-6)";
      case TAG_STATUS.ERROR:
        return "var(--palette-base-red-6)";
      case TAG_STATUS.INFO:
        return "var(--palette-base-blue-6)";
      case TAG_STATUS.IN_PROGRESS:
        return "var(--palette-base-orange-6)";
      case TAG_STATUS.CLOSE:
        return "var(--palette-base-verified-text)";
      case TAG_STATUS.DEFAULT:
      default:
        return "var(--palette-base-neutral-7)";
    }
  };

  const getColorBorder = () => {
    switch (status) {
      case TAG_STATUS.SUCCESS:
        return "var(--palette-base-green-2)";
      case TAG_STATUS.ERROR:
        return "var(--palette-base-red-2)";
      case TAG_STATUS.INFO:
        return "var(--palette-base-blue-2)";
      case TAG_STATUS.IN_PROGRESS:
        return "var(--palette-base-orange-3)";
      case TAG_STATUS.DEFAULT:
      default:
        return "var(--palette-base-neutral-4)";
    }
  };

  return (
    <div
      className={classNames(className, "tag-container", {
        "tag-container__sm": size === "sm",
        "tag-container__md": size === "md",
      })}
      style={{
        backgroundColor: backgroundColor || getBackgroundColor(),
        color: color || getColorText(),
        borderWidth: isShowBorder ? 1 : 0,
        borderColor: colorBorder || getColorBorder(),
        borderStyle: "solid",
      }}
    >
      <span
        className={classNames("tag-wrapper", {
          "tag-wrapper__sm": size === "sm",
          "tag-wrapper__md": size === "md",
        })}
      >
        {isShowDot && (
          <div
            className="tag-dot"
            style={{
              backgroundColor: colorDot || getColorText(),
            }}
          />
        )}
        {countCharacters && countCharacters > 0 ? (
          <Tooltip title={value}>
            {CommonService.limitWord(value, countCharacters)}
          </Tooltip>
        ) : (
          <>{value}</>
        )}
      </span>
      {typeof action === "function" && action && (
        <div className="tag-clear" onClick={action}>
          <Close size={16} color="var(--palette-base-neutral-6)" />
        </div>
      )}
    </div>
  );
}

export default Tag;
